$(function () {
  let queryParams = new URLSearchParams(window.location.search);

  // Pagination
  const content = $("#js-pagination-content");
  const target = $(content.data("target"));
  const itemSelector = $(content.data("item"));
  const prevBtn = $("#js-pagination-prev");
  const nextBtn = $("#js-pagination-next");
  const pageInput = $("#js-pagination-current");

  let currentPage = queryParams.get("page")
    ? Number(queryParams.get("page"))
    : 1;
  const perPage = Number(content.data("per-page"));
  const totalItems = Number(content.data("total"));
  const pagesCount = Math.ceil(totalItems / perPage);

  const changePage = (page) => {
    if (page < 1) {
      page = 1;
    }

    if (page > pagesCount) {
      page = pagesCount;
    }

    content.find(itemSelector).each(function (index) {
      if (
        index < page * perPage &&
        index >= (page - 1) * perPage &&
        index < totalItems
      ) {
        $(this).removeClass("d-none");
      } else {
        $(this).addClass("d-none");
      }
    });

    if (content.parents(".rd-modal").length) {
      content.parents(".rd-modal").scrollTop(0);
      return false;
    }

    // $(window).scrollTop(0);
    $(target).scrollTop(0);
    // queryParams.set("page", page);
    // history.replaceState(null, null, `?${queryParams.toString()}`);
    return false;
  };

  pageInput.on("change", function () {
    const page = Number($(this).val());
    if (page >= 1 && page <= pagesCount) {
      currentPage = page;
    } else {
      currentPage = page < 1 ? 1 : pagesCount;
    }
    $(this).val(currentPage);
    changePage(currentPage);
  });

  prevBtn.on("click", function () {
    if (currentPage > 1) {
      currentPage--;
      pageInput.val(currentPage);
      pageInput.trigger("change");
    }
  });

  nextBtn.on("click", function () {
    if (currentPage < pagesCount) {
      currentPage++;
      pageInput.val(currentPage);
      pageInput.trigger("change");
    }
  });

  $("#js-pagination-total").text(pagesCount);
  pageInput.val(currentPage);
  pageInput.trigger("change");
});
